<template lang="pug">
  .row(:class="{child: is_child}")
    .column
      .label
        slot(name="label")
      .value
        slot(name="value")
    slot.row(name="row")
</template>

<script lang="js">
export default {
  props: {
    is_child: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="sass" scoped>
.row
  display: flex
  padding: 10px 0
  align-items: center
  flex-wrap: wrap
  width: 100%
  .column
    width: 100%
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between

    .label
      width: 160px
      font-size: 20px
    .value
      margin-left: 10px
      font-size: 28px
      .radio
        position: relative
        height: 90px
        .check
          position: absolute
          right: -10px
          bottom: 0
          min-width: 100px
      .price
        span.tax
          font-size: 16px
          color: #999
.child
  margin-left: 10px


@media screen and (max-width: $screen-sp)
  .row
    .column
      flex-direction: column
      border-bottom: solid 1px $deep-gray
      justify-content: space-between
      .label
        width: 100%
      .value
        width: 100%
        .price
          text-align: right

</style>